import { FieldErrorsSharedProps } from "@certn/cascadia/components/inputs/_assets/input-wrapper/types";

import { FormFeedbackRAC } from "./FormFeedbackRAC";
import { Stack } from "../../../../foundations/grid-layout/Stack";

export interface FieldErrorsProps extends FieldErrorsSharedProps {
  children?: React.ReactNode;
}

export function FieldErrors(props: FieldErrorsProps) {
  const { children } = props;

  const errors = Array.isArray(children)
    ? children.filter(Boolean)
    : [children].filter(Boolean);

  if (errors.length < 1) {
    return null;
  }

  return (
    <Stack gap="space-0" className="has-errors">
      {errors.map((error) => (
        <FormFeedbackRAC key={error} type="invalid">
          {error}
        </FormFeedbackRAC>
      ))}
    </Stack>
  );
}
